import { FC, useCallback, useState } from "react"
import { discussionDeleteApi } from "src/domain/api/discussion/discussionDeleteApi"
import { Discussion } from "src/domain/entities/discussion"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	discussion: Discussion
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const DiscussionDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	discussion,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleDiscussionDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await discussionDeleteApi({ id: discussion.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [discussion, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Discussion: ${discussion.text}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleDiscussionDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
